const TZ = "Asia/Kolkata";

const trim2 = (x) => parseFloat(x.toFixed(2)).toString();

export const inr = (n) => (n === null || n === undefined || n === "" ? "—" : "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 }));

export const inrCompact = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  const v = Number(n);
  if (v >= 1e7) return `₹${trim2(v / 1e7)}\u00A0Cr`;
  if (v >= 1e5) return `₹${trim2(v / 1e5)}\u00A0L`;
  return inr(v);
};

export const budgetRange = (min, max) => {
  if (!min && !max) return "—";
  if (min && max) return `${inrCompact(min)} – ${inrCompact(max)}`;
  return min ? `${inrCompact(min)}+` : `Up to ${inrCompact(max)}`;
};

function parts(iso) {
  const p = new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(new Date(iso));
  const o = {};
  p.forEach((x) => { o[x.type] = x.value; });
  if (o.hour === "24") o.hour = "00";
  return o;
}

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const o = parts(iso);
  return `${o.day}-${o.month}-${o.year}`;
};

export const fmtDateOnly = (ymd) => {
  if (!ymd) return "—";
  const [y, m, d] = ymd.split("-");
  return `${d}-${m}-${y}`;
};

export const fmtTime = (iso) =>
  new Date(iso).toLocaleTimeString("en-IN", { timeZone: TZ, hour: "2-digit", minute: "2-digit", hour12: true }).toUpperCase();

export const fmtDateTime = (iso) => (iso ? `${fmtDate(iso)}, ${fmtTime(iso)}` : "—");

export const toISTInput = (iso) => {
  if (!iso) return "";
  const o = parts(iso);
  return `${o.year}-${o.month}-${o.day}T${o.hour}:${o.minute}`;
};

export const fromISTInput = (v) => (v ? new Date(`${v}:00+05:30`).toISOString() : null);

const dayKey = (iso) => {
  const o = parts(iso);
  return `${o.year}-${o.month}-${o.day}`;
};

export const isOverdue = (iso) => !!iso && dayKey(iso) < dayKey(new Date().toISOString());
export const todayYMD = () => dayKey(new Date().toISOString());
export const isOverdueYMD = (ymd) => !!ymd && ymd < todayYMD();
export const dayLabel = (iso) => {
  const k = dayKey(iso);
  if (k === todayYMD()) return "Today";
  if (k === dayKey(new Date(Date.now() - 864e5).toISOString())) return "Yesterday";
  return fmtDate(iso);
};
export const sameDay = (a, b) => dayKey(a) === dayKey(b);
export const isToday = (iso) => !!iso && dayKey(iso) === dayKey(new Date().toISOString());

export const relDay = (iso) => {
  if (!iso) return "—";
  const today = dayKey(new Date().toISOString());
  const tomorrow = dayKey(new Date(Date.now() + 864e5).toISOString());
  const yest = dayKey(new Date(Date.now() - 864e5).toISOString());
  const k = dayKey(iso);
  const label = k === today ? "Today" : k === tomorrow ? "Tomorrow" : k === yest ? "Yesterday" : fmtDate(iso);
  return `${label}, ${fmtTime(iso)}`;
};

export const areaText = (a, unit) => (a ? `${Number(a).toLocaleString("en-IN")} ${unit || "sq ft"}` : "—");
